import PubSub from 'pubsub-js';
import TOPICS from './topics';

const pubSub = () => ({
  publish: PubSub.publish,
  subscribe: PubSub.subscribe,
  TOPICS,
});

export default pubSub();
